import React from 'react';

export default ({ color = '#fff' }: { color: string }): JSX.Element => (
  <svg width="8" height="5" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.5 0.5L3.95 3.05L2.45 1.55L0.5 3.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.70038 0.5H6.50038V2.3"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
